import React from 'react';
import Button from './button';

const Modal = ({ onClose, children }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-4 rounded-lg">
        {children}
        <Button onClick={onClose}>Cerrar</Button>
      </div>
    </div>
  );
};

export default Modal;